<app-header-ad [position]="'top-fixed'"></app-header-ad>
<header class="container-fluid site-head">
  <div class="container">
    <div class="row">
      <div class="col-md-2 col-xl-2"></div>
      <div class="col-md-8 col-xl-7">
        <div class="main-logo-wrap">
          <a href="#" [routerLink]="['/homeview']">
            <img class="logo" src="/assets/img/header-logo-color.png" alt="Law Self logo" />
          </a>
        </div>
      </div>
      <div class="block-desktop col-md-2 col-xl-2">
        <div>
          <h5 *ngIf="getUserName()" class="welcome-text">
            Welcome, {{getUserName()}}
          </h5>
        </div>
      </div>
    </div>
  </div>
  <div style="height: 2px"></div>
  <div class="container">
    <div class="row">
      <div class="col-xl-3 col-lg-12"></div>
      <div class="col-xl-5 col-xs-12 margin-bottom-30 text-align-center" style="margin-top: 2px">
        <h6 class="sub-title">A Project of <strong><a id="highlight-npc" rel="noopener"
              href="https://nationalparalegal.edu" target="_blank">National Paralegal College</a></strong></h6>
      </div>
      <div class="col-xl-4 col-md-4" style="padding-right: 0px !important">
        <div *ngIf="!getUserName()" class="login-btn" style="text-align: right">
          <a id="login-register" class="btn login-register-buttons margin-right-5" [routerLink]="['/loginview']"><i
              class="fa fa-user login-register-text" aria-hidden="true"></i> Log in </a>
        </div>
        <div *ngIf="getUserName()" class="login-btn">
          <a class="logout-account-buttons margin-right-5" [routerLink]="['/accountview']"><i class="fa fa-user"
              aria-hidden="true"></i>My Account</a>
          <a class="logout-account-buttons" [routerLink]="" (click)="doLogout()"><i
              class="fa fa-sign-out margin-left-10" aria-hidden="true"></i>Log out</a>
        </div>
      </div>
    </div>
  </div>
</header>
<nav-menu></nav-menu>

<alert></alert>

<div class='row'>
  <div class='col-sm-12 body-content'>
    <router-outlet></router-outlet>
  </div>
</div>

<footer class="bg-dark">
  <div class="container">

    <div class="row margin-left-10 margin-right-10 margin-top-30">
      <div class="col-lg-4 col-md-6 col-sm-12" style="text-align: center; margin-bottom: 10px">
        <div class="organization-heading" style="border-radius: 10px; height: 150px">
          <div style="position: relative; text-align: center; margin: auto">
            <img loading="lazy" width="50" height="50" src="/assets/img/Phone.png" alt="Phone" style="margin-top: 10px">
          </div>
          <div class="row margin-bottom-20 padding-left-20 padding-top-5 " style="position: relative">
            <table style="position: absolute; left: 50%; margin-right: -50%; transform: translate(-50%, 0)">
              <tr>
                <td style="text-align: left; font-weight: 900; font-size: .9em">Phone:</td>
                <td style="text-align: left; padding-left: 5px; font-size: .9em">800-500-3136</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12" style="text-align: center; margin-bottom: 10px">
        <div class="organization-heading text-center" style="border-radius: 10px; height: 150px;">
          <div class="margin-top-30 padding-bottom-5" style="position: relative; text-align: center; margin: auto">
            <h2 style="background-color: #1c2632 !important">Follow Us</h2>
          </div>
          <table width="126" style="margin: auto">
            <tr>
              <td>
                <a rel="noopener" target="_blank" style="text-align: center" title="YouTube"
                  href="https://www.youtube.com/channel/UCSxkqyENz-czORfYZipgt1w"><img loading="lazy" alt="Youtube"
                    style="width:40px; height: 40px" src="/assets/img/Youtube logo.png" /></a>
              </td>
              <td>
                <a rel="noopener" target="_blank" style="text-align: center" title="Facebook"
                  href="https://www.facebook.com/LawShelfNPC"><img loading="lazy" alt="Facebook"
                    style="width:40px; height: 40px" src="/assets/img/Facebook logo.png" /></a>
              </td>
              <td>
                <a rel="noopener" target="_blank" style="text-align: center" title="Instagram"
                  href="https://www.instagram.com/lawshelf"><img loading="lazy" alt="Instagram"
                    style="width:40px; height: 40px" src="/assets/img/Instagram logo.png" /></a>
              </td>
            </tr>
            <tr>
              <td>
                <a rel="noopener" target="_blank" style="text-align: center" title="Twitter"
                  href="https://twitter.com/LawShelf_NPC"><img loading="lazy" alt="Twitter"
                    style="width:40px; height: 40px" src="/assets/img/Twitter Logo.png" /></a>
              </td>
              <td>
                <a rel="noopener" target="_blank" style="text-align: center" title="Pinterest"
                  href="https://www.pinterest.com/LawShelf"><img loading="lazy" alt="Pinterest"
                    style="width:40px; height: 40px" src="/assets/img/Pinterest Logo.png" /></a>
              </td>
              <td>
                <a rel="noopener" target="_blank" style="text-align: center" title="LinkedIn"
                  href="https://www.linkedin.com/company/lawshelf"><img loading="lazy" alt="LinkedIn"
                    style="width:40px; height: 40px" src="/assets/img/LinkedIn logo.png" /></a>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-12" style="text-align: center; margin-bottom: 10px">
        <div class="organization-heading" style="border-radius: 10px; height: 150px">
          <div style="position: relative; text-align: center; margin: auto">
            <img loading="lazy" alt="Email" width="50" height="50" src="/assets/img/Email.png" style="margin-top: 10px">
          </div>
          <div class="margin-bottom-20 margin-top-5" style="position: relative; text-align: center; margin: auto">
            <a class="btn align-top"
              style="color: white; font-size: 16px; font-weight: 900; width: 170px; border-width: 3px; border-color: white; border-style: solid; margin-bottom: 2px; padding-bottom: 5px !important"
              [routerLink]="['/contactusview']">Email Us</a>
          </div>
        </div>
      </div>

    </div>


    <hr style="border-color: #3f4962; margin: 3px" />
    <div class="footer-logo-wrap">
      <div class="block-center" style="width: 125px;margin: 0 auto;">
        <a href="/">
          <img loading="lazy" class="footer-logo" src="/assets/img/footer-logo.svg" alt="LawShelf logo" />
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4 col-xs-12 text-align-center">
        <a style="color: #e9b400; text-transform: uppercase; font-size: 16px;" [routerLink]="['/aboutusview']">About
          Us</a>
      </div>
      <div class="col-sm-4 col-xs-12 text-align-center">
        <a style="color: #e9b400; text-transform: uppercase; font-size: 16px;" [routerLink]="['/sitemapview']">Site
          Map</a>
      </div>
      <div class="col-sm-4 col-xs-12 text-align-center">
        <a style="color: #e9b400; text-transform: uppercase; font-size: 16px;"
          [routerLink]="['/termsofserviceview']">Terms of Service</a>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 margin-top-10 margin-bottom-10 text-align-center">
        <span style="font-weight: 700" class="footer-copy text-align-center">&copy;{{getYear()}} <a rel="noopener"
            href="https://nationalparalegal.edu" style="font-weight: 700" target="_blank">National Paralegal
            College</a></span>
      </div>
    </div>

  </div>
</footer>